import { useQuery } from '@tanstack/react-query';
import { groupBy } from 'lodash';

import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

import { getLevelUpCompetencyData } from '../services';

const getData = async ({
  employeeId,
  targetRole,
  changeSelectedRole = () => {},
  setFunctionAndRoleNotSet = () => {},
}) => {
  try {
    const res = await getLevelUpCompetencyData({
      employeeId,
      targetRole,
    });
    changeSelectedRole({ isTargetRole: res?.tableData?.isTargetRole });
    const competenciesGroupedByCompetencyStatus = groupBy(res?.tableData?.competencies, 'progress');
    return { ...res, competenciesGroupedByCompetencyStatus };
  } catch (err) {
    if (err.status === 422) {
      setFunctionAndRoleNotSet(true);
    } else {
      console.error('Error fetching level up competency data : ', err);
    }
  }
};

export const useLevelUpCompetencyData = ({
  employeeId,
  targetRole,
  changeSelectedRole = () => {},
  setFunctionAndRoleNotSet,
}) =>
  useQuery(
    [REACT_QUERY_KEYS.LevelUpCompetencyData, employeeId, targetRole],
    () => {
      if (employeeId) {
        return getData({
          employeeId,
          targetRole,
          changeSelectedRole,
          setFunctionAndRoleNotSet,
        });
      }
    },
    { enabled: !!employeeId }
  );
